/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { Box } from '@mui/material';
import React from 'react';
import { ToolContainerDraggable } from '@opengeoweb/shared';

interface DraggablePluginProps {
  children: React.ReactNode;
  title?: string;
  onClose?: () => void;
  startTop?: number;
  startLeft?: number;
  startWidth?: number;
  startHeight?: number;
}

export const DraggablePlugin = ({
  children,
  title,
  onClose,
  startTop = 60,
  startLeft = 16,
  startWidth = 360,
  startHeight = 300,
}: DraggablePluginProps): React.JSX.Element => {
  return (
    <ToolContainerDraggable
      bounds="parent"
      minHeight={150}
      minWidth={200}
      onClose={onClose}
      startPosition={{ top: startTop, left: startLeft }}
      startSize={{ width: startWidth, height: startHeight }}
      title={title}
    >
      <Box
        data-testid="draggable-plugin-wrapper"
        sx={{
          width: '100%',
          height: '100%',
          minWidth: 0,
          minHeight: 0,
          display: 'flex',
          overflow: 'hidden',
          bgcolor: 'common.black',
        }}
      >
        {children}
      </Box>
    </ToolContainerDraggable>
  );
};
